import * as React from "react"
import {Grid} from "@mui/material";
import { TourTarget } from "@tour"

import PriceEvolutionTabsBlock from "./TabsBlock";
import PriceEvolutionWidget from "./Widget";
import PriceEvolutionChartBlock from "./Chart";
import PriceEvolutionTablePricingBlock from "./TablePricing";
import PriceEvolutionTabsTableBlock from "./TabsTableBlock";
import PriceEvolutionTableMinMax from "./TableMinMax";


export default function PriceEvolutionContent() {
    return <Grid container spacing={2}>

		<Grid item xs={12} data-tour="price-evolution-tabs">
			<PriceEvolutionTabsBlock />
		</Grid>

		<Grid item xs={12} data-tour="price-evolution-widget">
			<PriceEvolutionWidget />
		</Grid>

		<Grid item xs={12} data-tour="price-evolution-chart">
			<PriceEvolutionChartBlock />
		</Grid>

		<Grid item xs={12} sx={{ position: "relative" }}>
			<TourTarget name="price-evolution-table" height={450} />
			<PriceEvolutionTabsTableBlock />
		</Grid>

		<Grid item xs={12}>
			<PriceEvolutionTableMinMax />
		</Grid>

		<Grid item xs={12}>
			<PriceEvolutionTablePricingBlock />
		</Grid>
    </Grid>
}
